import { CxEvent } from '@spartacus/core';

export class Ga4GgButtonClickEvent extends CxEvent {
  event?: string;
  click_text?: string;
  click_url?: string;
  visitor_type?: string;
}
